<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'FilesystemLabel',

    functional: true,

    props: {
        filesystem: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        const isEmpty = !props.filesystem || props.filesystem.length === 0;

        const children = [
            (isEmpty)
                ? null
                : createElement('a', {
                    attrs: {
                        href: 'cpub:' + props.filesystem,
                        target: '_blank',
                    },
                }, [props.filesystem]),
        ];

        data.props = {
            item: isEmpty ? null : '',
            iconClass: 'far fa-fw fa-folder',
            none: parent.$t('common.labels.filesystem.nil'),
        };

        return createElement(DataLabel, data, children);
    },
};
</script>
